import React, { useContext } from 'react';
import { AppContext, IAppContext } from 'appState/appContext';
import { CustomersContext, ICustomersContext } from '../../customersState/customersContext';
import { EntityStatus } from 'types';
import { ActiveCustomersList } from './components/ActiveCustomersList/ActiveCustomersList';
import { ArchivedCustomersList } from './components/ArchivedCustomersList/ArchivedCustomersList';
import { DeletedCustomersList } from './components/DeletedCustomersList/DeletedCustomersList';
import { PaginationComponentNew } from 'components/PaginationComponent/PaginationComponentNew';
import { NoResultsFoundNew } from 'components/NoResultsFound/NoResultsFoundNew';
import style from './Customers.module.scss';

export const Customers: React.FC = () => {
	const { isLoading } = useContext<IAppContext>(AppContext);
	const { changeCurrentPage, customers, currentPage, countOfItems, status } =
		useContext<ICustomersContext>(CustomersContext);

	return (
		<>
			{customers.customerCount ? (
				<div className={style.container} data-test="Customers">
					{status === EntityStatus.Active && <ActiveCustomersList />}
					{status === EntityStatus.Archived && <ArchivedCustomersList />}
					{status === EntityStatus.Deleted && <DeletedCustomersList />}
					<PaginationComponentNew
						currentPage={currentPage}
						countOfItems={countOfItems}
						entitiesCount={customers.customerCount}
						changeCurrentPage={changeCurrentPage}
					/>
				</div>
			) : (
				<NoResultsFoundNew isVisible={!isLoading} />
			)}
		</>
	);
};
